export const commonPT = require("./commonPT.json");
export const pagesPT = require("./pagesPT.json");
export const messagesPT = require("./messagesPT.json");
